import path from 'node:path';
import os from 'node:os';

/** Yield while walking paths or inserting rows (keeps bridge responsive). */
export const INDEX_WORK_YIELD_EVERY = 128;

export const INDEX_DIR = path.join(os.homedir(), '.buildautomaton');
export const INDEX_HASH_LEN = 16;
